import React from 'react';

import PanelWrapper from '@/components/PanelWrapper/PanelWrapper';
import { Button } from '@/components/shadcn/ui/button';
import { Skeleton } from '@/components/shadcn/ui/skeleton';

import SwapInputsToggleButton from './components/SwapPanel/SwapInputsToggleButton/SwapInputsToggleButton';

const SwapLoadingSkeleton: React.FC = () => {
  return (
    <PanelWrapper className="relative w-full transition-all duration-150 md:w-[450px]">
      <div className="flex w-full flex-col gap-2">
        <div className="bg-background h-[117px] w-full rounded-xl p-2.5 sm:px-2.5 md:px-4">
          <div className="flex w-full flex-col gap-2">
            <Skeleton className="h-[21px] w-[80px] rounded-lg" />

            <div className="flex items-center justify-between gap-4">
              <Skeleton className="h-[40px] w-[70%] rounded-lg" />
              <Skeleton className="h-[36px] w-[25%] rounded-lg" />
            </div>

            <div className="flex items-center justify-between gap-1">
              <Skeleton className="h-[20px] w-[120px] rounded-lg" />
              <Skeleton className="h-[20px] w-[120px] rounded-lg" />
            </div>
          </div>
        </div>

        <div className="relative z-1 -my-6 flex w-full justify-center">
          <SwapInputsToggleButton />
        </div>

        <div className="bg-background h-[117px] w-full rounded-xl p-2.5 sm:px-2.5 md:px-4">
          <div className="flex w-full flex-col gap-2">
            <Skeleton className="h-[21px] w-[80px] rounded-lg" />

            <div className="flex items-center justify-between gap-4">
              <Skeleton className="h-[40px] w-[70%] rounded-lg" />
              <Skeleton className="h-[36px] w-[25%] rounded-lg" />
            </div>

            <div className="flex items-center justify-between gap-1">
              <Skeleton className="h-[20px] w-[120px] rounded-lg" />
              <Skeleton className="h-[20px] w-[120px] rounded-lg" />
            </div>
          </div>
        </div>

        <div className="bg-background flex h-[60px] w-full items-center gap-2 rounded-xl p-2.5 sm:px-2.5 md:px-4">
          <Skeleton className="h-[24px] w-8 rounded-xl" />
          <Skeleton className="h-[21px] w-full rounded-xl" />
          <Skeleton className="h-[24px] w-8 rounded-xl" />
        </div>

        <Button disabled className="min-h-14 w-full rounded-xl text-base sm:px-2.5 md:px-4">
          Loading PACT SWAP...
        </Button>

        <div className="bg-background flex h-[60px] w-full items-center gap-2 rounded-xl p-2.5 sm:px-2.5 md:px-4">
          <Skeleton className="h-[24px] w-8 rounded-xl" />
          <Skeleton className="h-[21px] w-full rounded-xl" />
          <Skeleton className="h-[24px] w-8 rounded-xl" />
        </div>
      </div>
    </PanelWrapper>
  );
};

export default SwapLoadingSkeleton;
